import { render, staticRenderFns } from "./ChangeButtons.vue?vue&type=template&id=4e90bcd4&scoped=true&"
import script from "./ChangeButtons.vue?vue&type=script&lang=js&"
export * from "./ChangeButtons.vue?vue&type=script&lang=js&"
import style0 from "./ChangeButtons.vue?vue&type=style&index=0&id=4e90bcd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e90bcd4",
  null
  
)

export default component.exports